import React, { useState } from "react";
import Classes from "./GetStarted.module.css";

export default function GetStarted() {
    const [form, setForm] = useState({
        name: "",
        email: "",
        company: "",
        phone: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Form submitted:", form);
    };

    return (
        <section className={`${Classes.section} layoutPadding`}>
            <div className={Classes.wrapper}>
                <h2 className='homeTitle'> Get Started Today </h2>
                <p className='homeSubTitle'>
                    Submit your details and our team will guide you through the onboarding process.
                </p>

                <form onSubmit={handleSubmit} className={Classes.form}>
                    <label htmlFor="name">Name</label>
                    <input
                        id="name"
                        name="name"
                        type="text"
                        placeholder="Your full name"
                        value={form.name}
                        onChange={handleChange}
                        required
                    />

                    <label htmlFor="email">Email</label>
                    <input
                        id="email"
                        name="email"
                        type="email"
                        placeholder="your@email.com"
                        value={form.email}
                        onChange={handleChange}
                        required
                    />

                    <label htmlFor="company">Company</label>
                    <input
                        id="company"
                        name="company"
                        type="text"
                        placeholder="Your company"
                        value={form.company}
                        onChange={handleChange}
                    />

                    <label htmlFor="phone">Phone Number</label>
                    <input
                        id="phone"
                        name="phone"
                        type="tel"
                        placeholder="(123) 456 7890"
                        value={form.phone}
                        onChange={handleChange}
                    />

                    <button type="submit" className={Classes.submitBtn}>
                        Submit request
                    </button>
                </form>
            </div>
        </section>
    );
}
